import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import { getEnquiryList_action } from '../../../actions/adminAction/enquiry_action';
import moment from 'moment';
import Loader from '../../../utils/Loader';

class EnquiryList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false,
            isOtherPreName: false,
            CompanyName: '',
            EmailAddress: '',
            MemberID: '', currentPage: 1, recordsPerPage: 10, enquiryList: [],
            FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            window.scrollTo(0, 0)
            const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
            const EnquiryListModule = loginAccessList.find(module => module.ModuleName === "Enquiry List");

            if (EnquiryListModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = EnquiryListModule;

                if (!FullAccess && !ReadAccess) {
                    this.props.navigate('/login'); // Navigate to login if no access
                } else {
                    this.setState({
                        FullAccess: !!FullAccess,
                        ReadAccess: !!ReadAccess,
                        WriteAccess: !!WriteAccess,
                        UpdateAccess: !!UpdateAccess,
                        DeleteAccess: !!DeleteAccess,
                        DownloadAccess: !!DownloadAccess,
                        Is_SpecialAccess: !!Is_SpecialAccess,
                        SendAccess: !!SendAccess
                    });

                    if (FullAccess) {
                        this.setState({
                            ReadAccess: true,
                            WriteAccess: true,
                            UpdateAccess: true,
                            DeleteAccess: true,
                            DownloadAccess: true,
                            Is_SpecialAccess: true,
                            SendAccess: true
                        });
                    }
                }
            } else {
                this.props.navigate('/login');
            }

            if (loginAccessList.length) {
                this.getFillList(countryActionId, '', '', '', '').then(() => {
                    this.getFillList(industryActionId, '', '', '', '').then(() => {
                        this.getEnquiryList()
                    })
                })
            }
        }
    }

    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === countryActionId) {
                            this.setState({ countryList: data.data })
                            resolve(true)
                        }
                        else if (actionID === stateActionId) {
                            data.data.length > 0 && this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === cityActionId) {
                            data.data.length > 0 && this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === industryActionId) {
                            this.setState({
                                industryList: data.data,
                                // tempCityList: data.data,
                            })
                            resolve(true)
                        }
                    }
                })
        })
    }

    getEnquiryList() {
        const { isLoading, EmailAddress, CompanyName, } = this.state
        this.setState({ isLoading: true })
        this.props
            .getEnquiryList_action(CompanyName, EmailAddress)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({ isLoading: false, enquiryList: data.data })
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    navEnquiryView(id) {
        this.props.navigate('/enquiryForm', {
            state: {
                EnquiryID: id
            }
        })
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };


    enquiryRecord(enquiryList) {
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        <th>Company Name</th>
                        <th>Email</th>
                        <th>Designation</th>
                        <th>Query</th>
                        <th>View</th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {enquiryList.length > 0 ? enquiryList.map((data, i) => (
                        <tr>
                            <td>{data.CompanyName}</td>
                            <td>{data.Email}</td>
                            <td>{data.Designation}</td>
                            <td>{data.Query}</td>
                            <td className="text-center" style={{ width: '5%' }}>
                                <a
                                    // href="javascript:void(0);"
                                    onClick={(e) => this.navEnquiryView(data.EnquiryID)}
                                    title="View Invoice"
                                    className="load_document_icon mx-2"
                                    data-toggle="modal"
                                    data-target="#add_comment_modal"
                                >
                                    <i className="fa fa-eye" />
                                </a>
                            </td>

                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={8}>No Record Found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    render() {
        const { isLoading, industryList, countryList, EmailAddress, CompanyName, currentPage, enquiryList, isFilterShow, recordsPerPage,
            FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = enquiryList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(enquiryList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card shadow-none border mb-2" >
                                                <div className="card-header py-1">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Enquiry List</h6>
                                                    {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            className="btn btn-purple custom_btn"
                                                            title="Filter"
                                                            data-toggle="modal"
                                                            data-target="#filter_modal"
                                                            onClick={() => this.toggleFilterCollapse()}
                                                        >
                                                            <i className="fa fa-filter" />
                                                        </a>

                                                    </> : <></>}
                                                </div>
                                                <ul className="list-group list-group-flush">
                                                    {isFilterShow && <>
                                                        <li className="list-group-item">
                                                            <div className="row ">
                                                                <div className="col-xl-2 mb-3">
                                                                    <div class="form-group">
                                                                        <label>Company</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            required=""
                                                                            value={CompanyName}
                                                                            // onKeyDown={e => this.handleKeyDown(e)}
                                                                            onChange={(e) => this.setState({ CompanyName: e.target.value })}
                                                                        />
                                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 mb-3">
                                                                    <div class="form-group">
                                                                        <label>Email</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            required=""
                                                                            value={EmailAddress}
                                                                            // onKeyDown={e => this.handleKeyDown(e)}
                                                                            onChange={(e) => this.setState({ EmailAddress: e.target.value })}
                                                                        />
                                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 mb-3">
                                                                    < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getEnquiryList()}>
                                                                        Search
                                                                    </button>
                                                                    <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark  mr-2 ms-2' onClick={e => this.setState({
                                                                        EmailAddress: '', CompanyName: ''
                                                                    }, () => {
                                                                        this.getEnquiryList()
                                                                    })}>
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </>}
                                                </ul>
                                            </div>
                                            <div className="card shadow-none border">

                                                <div className="card-body p-2 pb-0">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                {this.enquiryRecord(currentRecords)}
                                                                {enquiryList.length > 0 ? (
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                        totalRecords={enquiryList.length}
                                                                        pageLength={recordsPerPage}
                                                                        setPageLength={this.updateRecordsPerPage}
                                                                    />
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div >
                </section >
                {/* <Footer /> */}

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getEnquiryList_action })(EnquiryList));
